module.exports = __webpack_public_path__ + "static/media/AI Analysis.da779d5f.svg";